
export const updateScoreAction = (id: string, score: 0 | 1) => {
  return {
    type: 'UPDATE_SCORE',
    data: { id, score },
  };
};
